import { createFeatureSelector, createSelector } from '@ngrx/store';
import { conversationFeatureKey } from './conversation.feature-key';
import { ConversationState } from './conversation.state';

export const selectConversationFeatureState = createFeatureSelector<ConversationState>(conversationFeatureKey);

export const selectConversationState = selectConversationFeatureState;

export const selectActiveConversation = createSelector(
  selectConversationState,
  (state: ConversationState) => state.activeConversation,
);

export const selectConversationHistory = createSelector(
  selectConversationState,
  (state: ConversationState) => state.conversationHistory,
);

export const selectSavedConversations = createSelector(
  selectConversationState,
  (state: ConversationState) => state.savedConversations,
);

export const selectSelectedConversationId = createSelector(
  selectConversationState,
  (state: ConversationState) => state.selectedConversationId,
);

export const selectQuickQuestions = createSelector(
  selectConversationState,
  (state: ConversationState) => state.quickQuestions,
);

export const selectLoading = createSelector(selectConversationState, (state: ConversationState) => state.loading);

export const selectSendingMessage = createSelector(
  selectConversationState,
  (state: ConversationState) => state.sendingMessage,
);

export const selectError = createSelector(selectConversationState, (state: ConversationState) => state.error);
